/*
 注意：！！！！
 这个不好用Hook实现，改用Class了
 Hook实现上主要涉及到loadPic的逻辑上的理念在Hook上和Class上的差异，
 Hook上loadPic里边 读取的list的数据是老的数据，没法被更新
  */
//  @ts-nocheck
import React, {
  useMemo,
  ReactNode,
  useEffect,
  useCallback,
  SetStateAction,
} from 'react';
import intl from 'react-intl-universal';
import { IComponentPhoto } from 'component';
import { inject, observer } from 'mobx-react';
import { map, filter, pairwise, BehaviorSubject } from 'rxjs';

import ListWrapper, {
  checkLoadMore,
  ILoadMoreResult,
} from '../Common/ListWrapper';
import RootStore from '../../store/RootStore';
import AllForBigPic from '../BigPic/AllForBigPic';
import AllForGalleryList from './AllForGalleryList';
import AllForIndicator from '../GalleryHome/AllForIndicator';
import { maxNumberByType } from '../ComponentNavigator/AllForBottom';

interface IGalleryListWrapper {
  children?: ReactNode;
  component: IComponentPhoto | null;
  // getList: (page: number, ...arg: any) => void;
  rootStore?: RootStore;
  isContainer?: boolean;
}

//  url => url('|"....'|")
export const getUrlFromBackgroundImageUrl = (url) => {
  if (url) {
    const match = url.match(/url\((['"]?)(.*?)\1\)/);
    if (match && match[2]) {
      return match[2];
    }
  }
  return '';
};

/**
 * 这个主要是用来实现下面 scrollToListItem 内部的动画
 * @constructor
 */
export const CloseAnimation = ({
  targetElementSelectorFunction,
  containerSelectorFunction,
  list,
  index,
}) => {
  const [indexChangeSubject$] = React.useState(() => new BehaviorSubject(-1));

  useEffect(() => {
    let currentIndex = -1;

    const getCurrentIndexSubscriber = indexChangeSubject$.subscribe((index) => {
      currentIndex = index;
    });

    const subscription = indexChangeSubject$
      .pipe(
        map((index) => index > -1),
        pairwise(),
        map(([prevIndex, currentIndex]) => {
          return prevIndex === false && currentIndex === true;
        }),
        filter(Boolean)
      )
      .subscribe(() => {
        const item = list[currentIndex];
        const originElements = document.querySelectorAll(
          targetElementSelectorFunction(item)
        );

        const lastElement = originElements[originElements.length - 1];

        if (lastElement) {
          const hasImage = lastElement.querySelector('img');

          const img = lastElement.querySelector('img') || lastElement;

          const imgRect = img.getBoundingClientRect();
          const tempElement = document.createElement('div');
          tempElement.style.position = 'fixed';
          tempElement.style.top = `${imgRect.top}px`;
          tempElement.style.left = `${imgRect.left}px`;
          tempElement.style.width = `${imgRect.width}px`;
          tempElement.style.height = `${imgRect.height}px`;
          tempElement.style.zIndex = '1000';
          tempElement.style.backgroundColor = 'black';
          tempElement.style.backgroundSize = 'contain';
          tempElement.style.backgroundRepeat = 'no-repeat';
          tempElement.style.backgroundPosition = 'center';
          if (hasImage) {
            tempElement.style.backgroundImage = `url(${img.src})`;
          } else {
            tempElement.style.backgroundImage =
              lastElement.style.backgroundImage;
          }
          document.body.appendChild(tempElement);

          tempElement.animate(
            [
              {
                top: 0,
                left: 0,
                width: '100vw',
                height: 'var(--vh)',
                // opacity: hasImage ? 1 : 0.3,
                opacity: 1,
              },
            ],
            {
              duration: 350,
              easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
            }
          ).onfinish = () => {
            tempElement.remove();
          };
        }
      });

    return () => {
      subscription.unsubscribe();
      getCurrentIndexSubscriber.unsubscribe();
    };
  }, [indexChangeSubject$, list]);

  useEffect(() => {
    indexChangeSubject$.next(index);
  }, [index]);

  const [itemBeforeClose, setItemBeforeClose] = React.useState(null);
  const container = useMemo(() => {
    if (!itemBeforeClose) {
      return null;
    }
    const selector = containerSelectorFunction(itemBeforeClose);
    return document.querySelector(selector);
  }, [itemBeforeClose]);

  const targetElement = useMemo(() => {
    if (!itemBeforeClose) {
      return null;
    }
    const selector = targetElementSelectorFunction(itemBeforeClose);
    const targetElements = document.querySelectorAll(selector);
    return targetElements.length
      ? targetElements[targetElements.length - 1]
      : null;
  }, [itemBeforeClose]);

  const closeAnimation = useCallback(() => {
    if (!targetElement || !container) {
      return;
    }
    setTimeout(() => {
      // 创建一个临时的动画元素
      const tempElement = document.createElement('div');
      tempElement.style.position = 'fixed';
      tempElement.style.top = '0';
      tempElement.style.left = '0';
      tempElement.style.width = '100vw';
      tempElement.style.height = 'var(--vh)';
      tempElement.style.zIndex = '1000';
      tempElement.style.backgroundColor = 'black';
      tempElement.style.backgroundPosition = 'center';

      const targetImage = targetElement.querySelector('img');
      tempElement.style.backgroundSize = 'contain';
      tempElement.style.backgroundRepeat = 'no-repeat';

      let isGalleryFind;

      if (targetImage) {
        //  这儿是第一层的图片, 也就是gallery列表页的图片
        tempElement.style.backgroundImage = `url(${targetImage.src})`;
        isGalleryFind = true;
      } else {
        isGalleryFind = false;
        const cloneTargetElement = targetElement.cloneNode(true) as HTMLElement;
        const backgroundImage = cloneTargetElement.style.backgroundImage;

        const hash = itemBeforeClose.hash;

        //  pinch-zoom-container > img >src.includes(hash)
        const containerImageList = document.querySelectorAll(
          '.pinch-zoom-container img'
        );
        let targetImage = null;
        for (let i = 0; i < containerImageList.length; i++) {
          const img = containerImageList[i];
          if (img.src.includes(hash)) {
            targetImage = img;
            break;
          }
        }

        const img = document.createElement('img');
        img.src = getUrlFromBackgroundImageUrl(backgroundImage);
        if (targetImage) {
          img.src = targetImage.src;
        } else {
          console.log('targetImage not found');
        }
        img.style.maxWidth = '100%';
        img.style.maxHeight = '100%';
        tempElement.appendChild(img);
        tempElement.style.display = 'flex';
        tempElement.style.justifyContent = 'center';
        tempElement.style.alignItems = 'center';
      }

      document.body.appendChild(tempElement);
      const targetRect = targetElement.getBoundingClientRect();
      const animation = tempElement.animate(
        [
          {
            top: `${targetRect.top}px`,
            left: `${targetRect.left}px`,
            width: `${targetRect.width}px`,
            height: `${targetRect.height}px`,
            //  这儿这样做的目的是因为gallery列表图片和放大图片是一样的, 但是根据头像找的却不一样, 如果都设置为1, 会有突兀感, 因为图片对应不起来
            opacity: isGalleryFind ? 1 : 0.1,
          },
        ],
        {
          duration: 300,
          // easing: 'ease-in-out',
          easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
        }
      );

      animation.onfinish = () => {
        tempElement.remove();
        setItemBeforeClose(null);
      };
    }, 0);
  }, [itemBeforeClose, container, targetElement]);

  useEffect(() => {
    if (index === -1) {
      //  关闭
      if (targetElement && container) {
        closeAnimation();
      }
    } else {
      //  打开
      const item = list[index];
      if (item) {
        setItemBeforeClose(item);
      }
    }
  }, [list, container, targetElement, index]);

  useEffect(() => {
    if (index === -1 && itemBeforeClose) {
      const selector = targetElementSelectorFunction(itemBeforeClose);
      const targetElements = document.querySelectorAll(selector);
      const targetElement = targetElements.length
        ? targetElements[targetElements.length - 1]
        : null;
      if (targetElement) {
        targetElement.scrollIntoView({
          block: 'center',
          inline: 'center',
        });
      }
    }
  }, [index]);

  return null;
};

class GalleryListWrapper extends React.Component<IGalleryListWrapper> {
  state = {
    currentIndex: -1,
    disableRefresh: false, //是否禁止刷新
  };
  refresh = () =>
    new Promise((resolve) => {
      console.log('refresh in pull');
      // @ts-ignore
      (
        document.querySelector('.decorate-container')! as HTMLDivElement
      ).scrollTop = 0;
      const result = this.props.rootStore!.galleryStore.loadPic({
        notmerge: true,
      });
      result && result.then((res: any) => resolve(res.data));
    });

  // 现在的设计上不管怎么样都需要loadMore一次
  loadMore = () =>
    new Promise<ILoadMoreResult>((resolve) => {
      const result = this.props.rootStore!.galleryStore.loadPic({
        uselasttime: true,
      });
      if (!result) {
        return resolve({
          nomore: true,
          message: '',
        });
      }
      return result.then(checkLoadMore).then(resolve);
    });
  //flag传true表示第一次进入(onLoad)，第一次加载和后续的加载主要在于第一次会初始化当前的theme（一列还是三列），后面不需要按照这个处理
  //lasttime传入true方便接下来的sorttype的处理
  //notmerge==true表示的是不需要合并之前的数组数据
  //orderchange用于表示当前的order和之前获取的列表的order已经发生了变换，此时需要考虑lasttime等值的处理

  clickImage = ({ id }: { index?: number; id: number }) => {
    //console.log(index,id);
    const list = this.getCurrentList();
    // id是必传项，所以一定有ID
    const realIndex = list.findIndex((one) => {
      return +one.id === +id;
    });
    const { jigsaw } = this.props.rootStore!.galleryStore;
    const { bottomShow } = jigsaw;
    if (bottomShow) {
      this.setJigsawList(realIndex);
    } else {
      this.setState({
        currentIndex: realIndex,
      });
    }
  };

  setJigsawList = (index: number) => {
    if (index === -1) {
      console.error('index is a must', index);
      return;
    }
    const list = this.getCurrentList();
    const theOne = list[index];
    const { jigsaw, setJigsaw } = this.props.rootStore!.galleryStore;
    const { jigsawList } = jigsaw;
    // mobx不能直接修改jigsawList
    const cloneList = [...jigsawList];
    const theId = theOne.id;
    const jIndex = jigsawList.findIndex((one) => {
      return one.id == theId;
    });
    if (jIndex > -1) {
      //找到了就删除
      cloneList.splice(jIndex, 1);
    } else {
      const maxKey =
        jigsaw.type === 'download' ? 'MAX_DOWNLOAD_NUM' : 'MAX_JIGSAW_NUM';
      //最多16张
      if (cloneList.length >= maxNumberByType(jigsaw.type)) {
        //
        this.props.rootStore!.uiStore.showAlert({
          content: intl.get(maxKey, {
            num: maxNumberByType(jigsaw.type),
          }),
        });
        return;
      }
      cloneList.push(theOne);
    }
    setJigsaw({ jigsawList: cloneList });
  };

  freezeRefresh = () => {
    this.setState({
      disableRefresh: true,
    });
  };
  enableRefresh = () => {
    this.setState({
      disableRefresh: false,
    });
  };
  eventListener = () => {
    //监听refresh
    window.addEventListener('photo-refresh', this.refresh, false);
    // 非常手段了
    window.addEventListener('freeze-refresh', this.freezeRefresh, false);
    window.addEventListener('enable-refresh', this.enableRefresh, false);
  };

  componentWillUnmount(): void {
    window.removeEventListener('photo-refresh', this.refresh);
    window.removeEventListener('freeze-refresh', this.freezeRefresh);
    window.removeEventListener('enable-refresh', this.enableRefresh);
  }

  checkFirstTag(): any {
    const result = {
      tag: '',
      person: false,
      hot: false,
    } as {
      [key: string]: any;
    };

    const { component } = this.props;
    if (component) {
      if (component.showall === false) {
        if (component.showperson === true) {
          result.person = true;
        } else if (component.showhot === true) {
          result.hot = true;
        } else {
          const galleryId = window.dataDetail
            ? window.dataDetail.id + ''
            : window.gallery.id + '';
          if (galleryId) {
            const targetGallery =
              this.props.rootStore!.pagedataStore.currentGallerys[galleryId];
            if (targetGallery && targetGallery.tags) {
              const tags = (targetGallery.tags || '').split(',');
              if (tags && tags.length) {
                result.tag = tags[0];
              }
            }
          }
        }
      }
    }

    return result;
  }

  componentDidMount(): void {
    this.props
      .rootStore!.pagedataStore.getGallerys([
        window.dataDetail ? window.dataDetail.id + '' : window.gallery.id + '',
      ])
      .then(() => {
        const options = this.checkFirstTag();
        this.props.rootStore!.galleryStore.loadPic({ first: true, ...options });
      });
    this.eventListener();
  }
  getCurrentList = () => {
    const { list, hot, hotList } = this.props.rootStore!.galleryStore;
    return hot ? hotList : list;
  };
  // getTotal = () => {
  //   const { total } = this.props.rootStore!.galleryStore;
  //   // 目前不管是获取的热门还是正常的列表，total是通用的
  //   // console.log(total)
  //   return total;
  // };

  indexChange = (s: SetStateAction<number>) => {
    const { galleryStore, uiStore } = this.props.rootStore!;
    const { total = -1 } = galleryStore;
    const currentIndex =
      typeof s === 'function' ? s(this.state.currentIndex) : s;

    // 最后一页的话不会做赋值操作
    // 注意，很多情况下根本不会出现这个情况，因为在内部逻辑上已经阻止了，比如PC上左右滑动
    if (currentIndex === total && total !== 0) {
      uiStore.showToast({
        content: intl.get('This is the last one photo'),
        time: 1000,
      });
      return;
    }
    // 这里的表现其实和大图页的滑动不太一致了，
    this.setState({ currentIndex });
  };

  getCurrentPayGood = () => {
    const { wxuserStore } = this.props.rootStore!;
    const { is_pay_down } = window.dataDetail
      ? window.dataDetail
      : window.gallery;
    if (Number(is_pay_down) > 0) {
      const good = wxuserStore.currentPayGood[String(is_pay_down)];
      return good ? good : undefined;
    }

    return undefined;
  };

  render() {
    const { props } = this;
    if (!props.component) {
      return <>{props.children}</>;
    }

    const { wxuserStore, galleryStore } = this.props.rootStore!;

    const { total = -1, loadPic, setList, jigsaw } = galleryStore;
    const { currentIndex, disableRefresh } = this.state;
    const { refresh, loadMore } = this;
    const realList = this.getCurrentList();
    return (
      <ListWrapper
        onRefresh={refresh}
        isContainer={props.isContainer}
        onLoadMore={loadMore}
        disable={currentIndex !== -1 || disableRefresh}
        scrollerChildrenSelector={`.decorate-container`}
        eventName={'gallery-list'}
        total={total}
      >
        {props.children}
        <AllForGalleryList
          list={realList}
          onClick={this.clickImage}
          component={props.component}
          total={total}
          jigsaw={jigsaw}
        />
        <AllForIndicator />
        <CloseAnimation
          containerSelectorFunction={() => {
            return '.decorate-container';
          }}
          targetElementSelectorFunction={(item: any) => {
            return `.img-wrapper[data-id="${item.id}"]`;
          }}
          list={realList}
          index={currentIndex}
          scrollToView
        />
        {/* 这个是为了实现关闭动画 */}
        <AllForBigPic
          currentPropIndex={currentIndex}
          setCurrentPropIndex={this.indexChange}
          loadPic={loadPic}
          total={total}
          list={realList}
          setList={setList}
          currentPayGood={this.getCurrentPayGood()}
          currentPayedImages={wxuserStore.currentPayedImages}
        />
        {/*}<AllForGallerySwitch />*/}
      </ListWrapper>
    );
  }
}

export default inject('rootStore')(observer(GalleryListWrapper));
